// extracted by mini-css-extract-plugin
module.exports = {"category-copy-container":"CategoryCopy_category-copy-container__m8LbH","has-category-dude-image":"CategoryCopy_has-category-dude-image__Y0Cb1"};